export default {
  en: {
    message: {
      login: "Sign in",
      email: "E-Mail",
      password: "Password",
      wrong_password: "Wrong username or password",
      remember_me: "Remember me",
      logga_in: "Sign in",
      forgot: "Forgot password",
      register: "Do not have an account? Register one here",
      register_account: "Register account",
      username: "User name",
      account_creation_error: "Error creating account",
      send: "Send",
      reg_password: "Enter new password",
      wrongemail: "Wrong E-Mail",
      change_password: "Change password",
      my_pages: "My Pages",
      any_company: "Company name (if applicable)",
      status: "Status",
      start_date: "Start Date",
      end_date: "End Date",
      action: "Action",
      completed: "Completed",
      pending: "Pending",
      view: "View",
      order_id : "Order Details",
      client: "Client",
      name: "Name",
      address: "Address",
      postnumber: "Postal code",
      city: "City",
      telephone: "Phone number",
      mobilephone: "Mobile phone number",
      fax: "Fax number",
      company_information: "Company Information",
      company_name: "Company Name",
      state: "Seat",
      share_capital: "Share Capital",
      number_of_shares: "Number of Shares",
      financial_year: "Financial Year",
      other: "Other",
      busness_description: "Object of the company",
      board_n_shareholders: "Board and shareholders",
      board_member: "Board member",
      commissioner: "Board member",
      deputy: "Deputy board member",
      president: "Chair of the board",
      ceo: "CEO",
      external_ceo: "Extranal CEO",
      external_signatory: "External signatory",
      notifiable: "Person authorized to receive services of process",
      shareholder: "Shareholder",
      number_of_shares2: "Number of shares",
      company: "Company",
      Company_drawing: "Signatory power",
      the_board: "The board",
      board_members_are_seprate: "The board members individually",
      board_members_deputy_board_members_are_seperate: "The board member and the deputy board member individually",
      two_board_members_together: "Two board members jointly",
      auditor: "Auditor",
      auditing_company: "Auditing bureau",
      principal_auditor: "Principal auditor",
      deputy_auditor: "Deputy auditor",
      auditor_must_not_be_registerd: "Auditor should not be registered",
      sharpened_home_delivery: "Pre-emption clause",
      family_law_exception: "Family law exception clause",
      pre_order_reservation: "Right of first refusal clause",
      subject_to_consent: "Consent clause",
      home_delivery_for_family_law_prisoners: "Right of first refusal clause with pre-emption clause regarding family law",
      pre_purcashe_home_delivery_for_family_law_prisoners: "Right of first refusal clause or consent clause with pre-emption clause regarding family law",
      nothing: "Nothing",
      other_requests: "Other requests",
      other2: "Other",
      purchase_and_change_documents_for_the_new: "I want all documents rgarding the purchase of the company within two hours via",
      email_with_digital_signing: "E- mail with option to sign digitally (Bank ID)",
      post: "Mail",
      cost_for_warehouse_company: "The cost for the shelf company should be invoices to",
      the_customer: "The contact person",
      new_wherehouse_company: "The new shelf company",
      parent_company: "Tha parent company",
      company_doc_required_format: "Company documents (share register, etc.) are preferred in the following format",
      digital_without_cert: "Digitally (without issued share certificates)",
      physical_in_company_folder: "Physically in a company folder (without issued share certificates)",
      physical_in_company_folder_with_share_cert: "Physically in a company folder (with issued share certificates)",
      copy_order: "Copy order",
      complete_order: "Complete the order",
      logout: "Log out",
      kopia: "Copy",
      Forbehall: "Reservation",
    },
  },
  sv: {
    message: {
      login: "Logga in",
      email: "E-Post",
      password: "Pasword",
      wrong_password: "Fel användarnamn eller lösenord",
      remember_me: "Kom ihåg mig",
      logga_in: "Logga in",
      forgot: "Glömt lösenord",
      register: "Har du inte ett konto? Registrera ett här",
      register_account: "Registrera konto",
      username: "Användarnamn",
      account_creation_error: "Fel när kontot skapades",
      send: "Skicka",
      reg_password: "Ange nytt lösenord",
      wrongemail: "Fel användarnamn",
      change_password: "ÄÄndra lösenord",
      my_pages: "Mina Sidor",
      any_company: "Ev. Företag",
      status: "Status",
      start_date: "Start Date",
      end_date: "End Date",
      action: "Handling",
      completed: "Fullbordad",
      pending: "Avvaktan",
      view: "Review",
      order_id : "Order Details",
      client: "Beställare",
      name: "Namn",
      address: "Adress",
      postnumber: "Postnr.",
      city: "Ort",
      telephone: "Telefon",
      mobilephone: "Mobiltelefon",
      fax: "Fax",
      company_information: "Bolagsuppgifter",
      company_name: "Företagsnamn",
      state: "Säte",
      share_capital: "Aktiekapital",
      number_of_shares: "Antal aktie",
      financial_year: "Räkenskapsår",
      other: "Annat",
      busness_description: "Verksamhetsbeskrivning",
      board_n_shareholders: "Styrelse och aktieägare",
      board_member: "Styrelsemedlem",
      commissioner: "Ledamot",
      deputy: "Suppleant",
      president: "Ordförande",
      ceo: "VD",
      external_ceo: "Extern VD",
      external_signatory: "Extern firmatecknare",
      notifiable: "Delgivningsbar person",
      shareholder: "Aktieägare",
      number_of_shares2: "Antal aktier",
      company: "Företag",
      Company_drawing: "Firmateckning",
      the_board: "Styrelsen",
      board_members_are_seprate: "Styrelseledamöterna var för sig",
      board_members_deputy_board_members_are_seperate: "Styrelseledamoten och styrelsesuppleanten var för sig",
      two_board_members_together: "Styrelseledamöterna två i förening",
      auditor: "Revisor",
      auditing_company: "Revisionsbolag",
      principal_auditor: "Huvudansvarig revisor",
      deputy_auditor: "Revisorssuppleant",
      auditor_must_not_be_registerd: "Revisor ska inte registreras",
      sharpened_home_delivery: "Skärpt hembud",
      family_law_exception: "Familjerättsligt undantag",
      pre_order_reservation: "Förköpsförbehåll",
      subject_to_consent: "Samtyckesförbehåll",
      home_delivery_for_family_law_prisoners: "Förköpsförbehåll med skärpt hembud vid familjerättsliga fång",
      pre_purcashe_home_delivery_for_family_law_prisoners: "Förköpsförbehåll eller samtyckesförbehåll samt skärpt hembud vid familjerättsliga fång",
      nothing: "Inget",
      other_requests: "Övriga önskemål",
      other2: "Övrigt",
      purchase_and_change_documents_for_the_new: "Jag önskar samtliga köpe- och ändringshandlingar för det nya lagerbolaget inom två timmar via",
      email_with_digital_signing: "E-post med digital signering (Bank-ID)",
      post: "Post",
      cost_for_warehouse_company: "Kostnaden för lagerbolaget skall faktureras",
      the_customer: "Beställaren",
      new_wherehouse_company: "Nya lagerbolaget",
      parent_company: "Moderbolaget",
      company_doc_required_format: "Bolagshandlingar (aktiebok etc.) önskas i följande format",
      digital_without_cert: "Digitala (utan aktiebrev)",
      physical_in_company_folder: "Fysiska i en bolagspärm (utan aktiebrev)",
      physical_in_company_folder_with_share_cert: "Fysiska i en bolagspärm (med aktiebrev)",
      copy_order: "Kopiera beställning",
      complete_order: "Färdigställ beställning",
      logout: "Logga ut",
      kopia: "Kopia",
      Forbehall: "Förbehåll",
    },
  },
};
